var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"payment-reminder-reports"}},[_c('summary-reports'),_c('client-table',{staticClass:"table"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }